import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import PrettyJson from '../../atomicos/PrettyJson';
import GridFieldView from '../../ancestros/reportes/vistaCard/Campo';
import { validacion } from 'lib.common';
/**
 * Genera una representación grafica simple de una cadena json valida o un objeto javascript.
 */
function JsonVista({ json, configuracion, ...other }) {
   const defaultProps = {
      xs: 12,
      sm: 6,
      container: true
   };

   return (
      <Grid container item {...other}>
         {Object.keys(json).map((item) => {
            let valor = null;
            let itemProps = {};
            let visible = true;
            if (configuracion && configuracion[item]) {
               const {
                  valorMostrar: valorFn,
                  visible: visibleItem,
                  ...otherItemProps
               } = configuracion[item];
               valor = valorFn || valor;
               itemProps = otherItemProps;
               visible = visibleItem && visible;
            }
            if (!visible) {
               return null;
            }
            let valorMostrar = validacion.esFuncion(valor) ? valor(json) : json[item];
            return (
               <GridFieldView key={item} {...defaultProps} titulo={item} {...itemProps}>
                  {valorMostrar &&
                     (validacion.esObjeto(valorMostrar) || valorMostrar instanceof Array) ? (
                     <PrettyJson objeto={valorMostrar} />
                  ) : (
                     valorMostrar
                  )}
               </GridFieldView>
            );
         })}
      </Grid>
   );
}
JsonVista.propTypes = {
   /**
    * Objeto el cual se desea representar de forma grafica.
    */
   json: PropTypes.object.isRequired,
   /**
    * Configuracion de cada una de la propiedades del objeto *json*.
    * 
    * Cada propiedad de este objeto debera tener el nombre de la propiedad de *json* que configura, puede contener las siguiente propiedades:
    * 
    * - *titulo*: nombre a mostrar para la propiedad.
    * - *valorMostrar*: Funcion para generar el valor que se desea mostrar, tomo como parametro el objeto *json*.
    * - *visible*: Si es __false__ la propiedad no sera mostrada.
    * - Cualquier otra propiedas de un [grid de Materia-UI](https://material-ui.com/api/grid/).
    */
   configuracion: PropTypes.objectOf(
      PropTypes.shape({
         titulo: PropTypes.string,
         valorMostrar: PropTypes.func,
         visible: PropTypes.bool
      })
   )
};

export default JsonVista;
